export const zIndex = {
  splitSecondScreenSlide: 1,
  mobileContainer: 1,
  confirmationBarContainer: 1,
  secondScreenFooter: 1,
  stickyHeader: 4,
  sidebar: 8,
};
